import { Button } from "@mui/material";
import styled from "styled-components";

export const ReceiptDetailContainer = styled.div`
  box-sizing: border-box;
  border-radius: 4px;
  padding: 18px;
  display: flex;
  align-items: center;
  margin-top: 10px;
`;

export const ReceiptDetailFooter = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  display: flex;
  padding: 16px 24px;
  align-items: center;
  justify-content: flex-end;
  background-color: #FAFAFA;
  gap: 10px;

  @media all and (min-width: 768px) {
    left: 80px;
    width: calc(100% - 80px);
  }
  @media all and (min-width: 992px) {
    left: 160px;
    width: calc(100% - 160px);
  }
`;

export const InactivateContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding: 4px 5px;
  &:hover {
    background: var(--Light-Primary-Shades-4p); 
  }
`;

export const ButtonDownload = styled(Button)`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid var(--luft-primary);
  padding: 8px 22px;
  color: var(--luft-primary);
  font-size: 15px;
  text-transform: none;
  font-weight: 500;
  line-height: 26px;
`;
